import React from 'react'
import Services from '../components/Services'

const Home = () => {
  return (
    <div>
      <Services/>
    </div>
  )
}

export default Home